export const DEFAULT_PAYMENT_THRESHOLD = 3000; // Default to $30.00 (in cents) when first enabled
